"use strict";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import { CssCustomProperties } from "./utility/_cssCustomProperties";
// import { animation } from "./modules/_animation";
// import * as animation from "./modules/_animation";
gsap.registerPlugin(EaselPlugin, ScrollTrigger, ScrollToPlugin);
window.addEventListener("DOMContentLoaded", () => {
  new CssCustomProperties();
});
// animation.init();
//

window.addEventListener("DOMContentLoaded", () => {
  stepLetter();
  riseUpText();
  fadeText();
  animTrigger();
  // spanWrapText();
  // scrollTop();
  initializeScrollTop();
  const entryButton = document.querySelector(".entry-button");
  const footerBg = document.querySelector(".footer-bg");
  const footerNav = document.querySelector(".footer-nav");
  entryButton.addEventListener("mouseover", () => {
    footerBg.style.filter = "brightness(0.4)";
    footerNav.style.opacity = ".4";
  });
  entryButton.addEventListener("mouseout", () => {
    footerBg.style.filter = "";
    footerNav.style.opacity = "";
  });
  const elementsWithAriaLabel = document.querySelectorAll("[aria-label]");

  elementsWithAriaLabel.forEach((element) => {
    // aria-label の値を取得
    let label = element.getAttribute("aria-label");
    // <br> と <br /> の両方のパターンを削除
    label = label.replace(/<br\s*\/?>/gi, "");
    // 更新した値を設定
    element.setAttribute("aria-label", label);
  });
});
// function spanWrapText(target) {
const spanWrapText = (target) => {
  const nodes = [...target.childNodes]; // ノードリストを配列にする
  let returnText = ""; // 最終的に返すテキスト

  for (const node of nodes) {
    if (node.nodeType == 3) {
      //テキストの場合
      const text = node.textContent.replace(/\r?\n/g, ""); //テキストから改行コード削除
      const splitText = text.split(""); // 一文字ずつ分割
      for (const char of splitText) {
        returnText += `<span>${char}</span>`; // spanタグで挟んで連結
      }
    } else {
      //テキスト以外の場合
      //<br>などテキスト以外の要素をそのまま連結
      returnText += node.outerHTML;
    }
  }
  return returnText;
};

const spanTexts = [...document.querySelectorAll(".js-text-span")];
for (const spanText of spanTexts) {
  spanText.innerHTML = spanWrapText(spanText);
  spanText.spans = spanText.querySelectorAll("span");
}
// }

const riseUpTextSet = {
  duration: 6,
  display: "inline-block",
  overflow: "hidden",
  opacity: 0,
  y: 100,
  ease: "power3",
};
const riseUpTextTo = {
  opacity: 1,
  y: 0,
  stagger: 0.06,
};
function riseUpText() {
  gsap.utils.toArray(".anim-riseup-text").forEach((item) => {
    spanWrapText(item);
    const child = item.getElementsByTagName("span");
    gsap.set(child, riseUpTextSet);
    gsap.to(child, {
      ...riseUpTextTo,
      scrollTrigger: {
        // scroller: ".container__inner",
        trigger: item,
        start: "top 75%",
      },
    });
  });
}
function fadeText() {
  const fadeTextSet = {
    duration: 6,
    display: "inline-block",
    overflow: "hidden",
    opacity: 0,
    x: 50,
    ease: "power3",
  };
  const fadeTextTo = {
    opacity: 1,
    x: 0,
    stagger: 0.03,
  };
  gsap.utils.toArray(".anim-fade-text").forEach((item) => {
    spanWrapText(item);
    const child = item.getElementsByTagName("span");
    gsap.set(child, fadeTextSet);
    gsap.to(child, {
      ...fadeTextTo,
      scrollTrigger: {
        trigger: item,
        start: "top 75%",
      },
    });
  });
}
function stepLetter() {
  const stepLetter = document.querySelectorAll(".js-step-text");
  stepLetter.forEach((item, index) => {
    gsap.to(item, {
      scrollTrigger: {
        trigger: item,
        start: "top 85%",
        duration: 1,
        x: 0,
        opacity: 1,
        // ease: "power2.out",
        stagger: {
          from: "start",
          amount: 1,
        },
      },
    });
  });
}
function animTrigger() {
  // inview的アニメトリガー
  const animTarget = document.querySelectorAll(".animItem");
  animTarget.forEach((item, index) => {
    gsap.to(item, {
      scrollTrigger: {
        // scroller: ".container__main",
        trigger: item,
        start: "top 85%",
        once: true,
        // markers: true,
        toggleClass: {
          targets: item,
          className: "is-visible",
        },
        stagger: 0.3,
      },
    });
  });
}
// - - - - - - - - - - - - - - - - - - - - - - - - - -
// image horizone scroll
// - - - - - - - - - - - - - - - - - - - - - - - - - -
const scrollArea = document.querySelectorAll(".js-scroll-alert");
// 検知
function createEventScrollX(ele) {
  this._past_scroll_left = 0;
  this.ev_scroll_x = new CustomEvent("scroll-x", {
    bubbles: true,
    cancelable: true,
  });
  this.dispatch_callback = function (ev) {
    var cuT = ev.currentTarget;
    var now_l = cuT.scrollLeft;
    if (now_l !== this.past_scroll_left) {
      ele.dispatchEvent(this.ev_scroll_x);
      this.past_scroll_left = now_l;
    }
  };

  var events = ["scroll", "touchmove"];
  events.forEach(
    function (ev, idx, arr) {
      ele.addEventListener(ev, this.dispatch_callback.bind(this), {
        capture: true,
        passive: true,
      });
    }.bind(this)
  );
}

for (let i = 0; i < scrollArea.length; i++) {
  var evX = new createEventScrollX(scrollArea[i]);
  scrollArea[i].addEventListener(
    "scroll-x",
    function (ev) {
      let target =
        ev.currentTarget.getElementsByClassName("js-touch-scroll")[0];
      target.classList.add("is-hidden");
    },
    { capture: true, passive: true }
  );
}
// - - - - - - - - - - - - - - - - - - - - - - - - - -
// scroll Top
// - - - - - - - - - - - - - - - - - - - - - - - - - -
const scrollTopButton = document.querySelector(".return-button");
const pageKv = document.querySelector(".kv");
const footer = document.querySelector(".footer");
const scrollTop = () => {
  scrollTopButton.addEventListener("click", () => {
    // e.preventDefault();
    gsap.to(window, {
      duration: 1,
      // ease: "power2.in",
      scrollTo: 0,
    });
  });
};
const initializeScrollTop = () => {
  gsap.to(scrollTopButton, {
    scrollTrigger: {
      trigger: pageKv,
      startTrigger: pageKv,
      start: "bottom top",
      endTrigger: footer,
      end: "top 90%",
      // marker: true,
      toggleClass: {
        targets: scrollTopButton,
        className: "js-visible",
      },
    },
  });
};
